import { render, staticRenderFns } from "./ProductCenterView.vue?vue&type=template&id=4aab2690&scoped=true"
import script from "./ProductCenterView.vue?vue&type=script&lang=js"
export * from "./ProductCenterView.vue?vue&type=script&lang=js"
import style0 from "./ProductCenterView.vue?vue&type=style&index=0&id=4aab2690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aab2690",
  null
  
)

export default component.exports